















































import {Component, Prop, Vue} from "vue-property-decorator";
import MealService from '../../services/MealService';
import commonHelper from '@/helpers/commonHelper';

@Component
export default class SelectMealVersion extends Vue {
    private versions: any[] = [];
    private loading: boolean = false;

    @Prop()
    private mainMeal: any | undefined;

    private async mounted() {
        this.loadVersion();
    }

    private async loadVersion() {
        try {
            this.loading = true;
            const { data } = await MealService.getMealVersions(this.mainMeal.id);
            this.versions = data;
        } catch (e) {

        } finally {
            this.loading = false;
        }
    }

    private async loadMeal(id: string) {
        try {
            this.loading = true;
            const version = this.versions.find((item) => item.id === id);
            let dayMeals = this.$store.getters.getDayMeals;
            dayMeals = dayMeals.filter((item: any) => item.id !== this.mainMeal.id);
            this.$store.dispatch('setDayMeals', [...dayMeals, version]);

            let dayFoods = this.$store.getters.getDayFoods;
            dayFoods = dayFoods.filter((item: any) => parseInt(item.mealid) !== parseInt(this.mainMeal.id));
            this.$store.dispatch('setDayFoods', dayFoods);
            if (!dayFoods.some((item: any) => parseInt(item.mealid) === parseInt(version.id))) {
                const { data } = await MealService.getMealFoods(version.id);
                this.$store.dispatch('addDayFoods', data);
            }
            this.$emit('close');
        } catch (e) {

        } finally {
            this.$emit('getDayTotalNutrients');
            this.loading = false;
        }
    }

    private getDietName(dietId: string) {
      const diets = this.$store.getters.getDiets;
      const diet = diets.find((item: any) => parseInt(item.id) === parseInt(dietId));
      return diet ? diet.name : '';
    }

    private getTodName(todNumber: number) {
      return commonHelper.getTodName(todNumber) || '';
    }

    private getFormattedDate(date: string) {
      if (!date || date === '') {
        return '';
      }
      return commonHelper.getDateString(date);
    }

    get targets() {
      return this.$store.getters.getTargets;
    }
}
